/* eslint-disable jsx-a11y/no-redundant-roles */
import React, { useState,useEffect } from 'react'
import { StartupTrancheDetail } from '../../../models/funddetails/StartupTrancheDetails';
import { VIEW_STARTUP_APPLICATION, BASE_URL } from "../../../constants/api";
import { Modal } from 'react-bootstrap';
import InstrumentComponent from './InstrumentComponent';
import { get, post } from '../../../effects/api/api.common';
import moment from "moment";

export var passId: number;
interface ITrancheProps {
  trancheDetailsModel: Array<StartupTrancheDetail>;
  applicationDetails:any;
  statusId1:any;
    evDate1:any;
    isPrefer1:any;
    sel:any;
    applicationStatusId:any;
}

function TrancheInfoComponent(props: ITrancheProps) {
  const { trancheDetailsModel,applicationDetails,statusId1,evDate1,isPrefer1,sel,applicationStatusId } = props;
  const [startUp, setStartUp] = useState<any>({});
  const[instrumentApproved,setInstrumentApproved]=useState<any>(applicationDetails?.data?.data?.Application_Details?.FundingDetails?.instrument_approved)
  const[comment,setComment]=useState<any>(applicationDetails?.data?.data?.Application_Details?.FundingDetails?.instrument_comment)
  //  const [isstatus,setIsStatus]=useState("")
  //  const [date,setIsDate]=useState("")
  //  const [pref,setPref]=useState("")
  var currentdatenew = moment().format("YYYY-MM-DD")

  if (trancheDetailsModel != undefined) {
    passId = trancheDetailsModel[0].startup_application_id;
  }
 const handelChange=(e: string)=>{
    setInstrumentApproved(e)
    //  console.log(e)
  }
  const handelComment=(e:string)=>{
    setComment(e)
  }
  const handelShowReport=()=>{
    setShowReport(false)
  }

  useEffect(() => {
      console.log(applicationStatusId,"46")
    setInstrumentApproved(applicationDetails?.data?.data?.Application_Details?.FundingDetails?.instrument_approved)
    setComment(applicationDetails?.data?.data?.Application_Details?.FundingDetails?.instrument_comment)
    // console.log(props,"latha")

  }, [applicationDetails]);

  const [showReport, setShowReport] = useState(false);


  return (
    <div>
      <div className='m-4 d-flex justify-content-center'>
      <div className='d-flex align-items-center justify-content-around mb-5'>
        <div>
          <label htmlFor="browser" className="form-label">Select instrument type to be approved:</label>
          <div>
            {/*  */}
            
              <div className="col-sm-12 col-md-8">
                {/* {console.log("instrumentApproved",instrumentApproved)} */}
              <div className={instrumentApproved==0 || instrumentApproved==null ?"select-custom":"select-custom dropdown-disabled"}>
                  <select className="form-control" disabled  name="entity_type" value={instrumentApproved} aria-label="Select Entity Type">
                      <option value="">Select</option>
                      {/* selected */}
                      <option value="funding_grant">Grant</option>
                      <option value="funding_debt">Debt</option>
                      <option value="funding_debenture">Debenture </option>
                  </select>
              </div>
              
          </div>
              
            
              

          </div>
          {instrumentApproved==0||instrumentApproved===null ?<span>Please select the instrument approved, else system won't allow you to move further</span>:null}
        </div>
        {/* instrument_comment */}
        <div className="vl vl-mr"></div>
        <div>
          <h6>Comment :-</h6>
          {startUp?.Application_Details?.FundingDetails.instrument_comment}
          {/* <textarea ></textarea> */}
          <textarea 
          disabled={true}
          style={{height:"100px",width:'200px'}}
          value={startUp?.Application_Details?.FundingDetails.instrument_comment ? startUp?.Application_Details?.FundingDetails.instrument_comment:comment}
          className="form-control" 
          />
        </div>
        {
        (
          (evDate1 < currentdatenew)&&((isPrefer1 == '7'&& statusId1 == '7' && sel == '1')||(statusId1 == '2' ||statusId1 == '3' ||statusId1 == '4'||statusId1 == '5'))?

        (    
          (applicationStatusId == 'Closed' || applicationStatusId == "Cancelled") ? <> </> :
        <a className="incubator-details-link" style={{marginLeft:'5px'}}>Edit</a>):((applicationStatusId == 'Closed' || applicationStatusId == "Cancelled") ? <> </> : <a className="incubator-details-link" style={{marginLeft:'5px'}} onClick={() => setShowReport(true)}>Edit</a>))}

        {/* {instrumentApproved==0||instrumentApproved===null ?<a className="incubator-details-link" style={{marginLeft:'5px'}} onClick={() => setShowReport(true)}>Edit</a>:null} */}
        {/* <a className="incubator-details-link" style={{marginLeft:'5px'}} onClick={() => setShowReport(true)}>Edit</a> */}
      </div>
      </div>
      

      {trancheDetailsModel != undefined &&
        trancheDetailsModel.length > 1
        ?
        <div className="row mt-1-5 justify-content-center">
          <div id="tranchestepper" className="col-md-12 bs-stepper">
            <div className="bs-stepper-header" role="tablist">
              {trancheDetailsModel.map((item, index) => (
                <div className={item.startup_tranches_statuses_label == "Disbursed" ? "step active" : "step"}>
                  <button
                    type="button"
                    className="step-trigger"
                    role="button"
                    id="stepper1trigger1"
                    aria-controls="tranche1-expand"
                  >
                    <span className="bs-stepper-circle tooltip tooltip-overwrite">
                      <span className="tooltiptext">
                        {' '}

                        <span> Released Amount: &#8377;{item.funds_requested > 0 ? item.funds_requested : 0} </span>

                        <br />

                        <span> Requested Date: {item.tranche_requested_date != null ? item.tranche_requested_date : "-"}</span>

                      </span>
                    </span>
                  </button>
                  {index + 1 == trancheDetailsModel.length ? (
                    ''
                  ) : (
                    <div className="bs-stepper-line"></div>
                  )}

                  <span className={item.startup_tranches_statuses_label =="Disbursed" ?"stepper-label-bold" :"stepper-label"}
                  >{item.tranche_number}</span>
                </div>
              ))
              }

            </div>
          </div>
        </div>
        : ''}


      <Modal
        show={showReport}
        onHide={() => setShowReport(false)}
        dialogClassName="modal-90w modal-xl modal-dialog-scrollable table-bordered table-hover"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            Instrument
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <InstrumentComponent 
             id={passId} 
             setInstrumentApproved={setInstrumentApproved} 
             instrumentApproved={instrumentApproved}
             comment={comment}
             setComment={setComment}
             handelComment={handelComment}
             handelChange={handelChange}
             handelShowReport={handelShowReport}
             
             />
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default TrancheInfoComponent;
